module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ws-modal', {
    attrs: {
      "title": _vm.dialog.title
    },
    on: {
      "on-ok": _vm.ok
    },
    model: {
      value: (_vm.dialog.show),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "show", $$v)
      },
      expression: "dialog.show"
    }
  }, [_c('div', _vm._l((_vm.dialog.contents), function(item) {
    return _c('p', {
      domProps: {
        "textContent": _vm._s(item)
      }
    })
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-8eefee3e!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/framework/tip.vue
// module id = 1148
// module chunks = 99